/**
 * Color constants for the SWV-MES application
 * Color names derived from color-name.com for consistency
 */

// Alert and notification colors
export const YELLOW_CANARY = " #f9f871"; // Canary yellow - used for alert/warning banners

// Text colors
export const BLACK = " #000000"; // Pure black - used for high-contrast text

// Background colors
export const CATSKILL_WHITE = " #eaebec"; // Catskill White - light gray background
export const LINK_WATER = " #f2f4f7"; // Link Water - alternative light gray background
export const ATHENS_GRAY = " #f2f4f7"; // Athens Gray - paper background color
export const CULTURED_GRAY = " #F8F8F9"; // Cultured Gray - unselected tab background
export const WHITE_COLOR = " #ffffff"; // White - selected tab background
export const BRIGHT_GRAY = " #e9ecef"; // Bright Gray - disabled input background

// Table and row colors
export const YELLOW_PENDING_ROW = " #fff3cd"; // Light yellow/cream - pending row highlight

// Border colors
export const ALTO = " #e0e0e0"; // Alto - light gray border

// Status colors - Pourback
export const PURPLE_HEART = " #9c27b0"; // Purple Heart - pourback status text
export const MAGNOLIA = " #f3e5f5"; // Magnolia - pourback status background

// Status colors - Declared (Success)
export const FERN = " #4caf50"; // Fern - declared/success status text
export const FROSTED_MINT = " #e8f5e9"; // Frosted Mint - declared/success status background

// Status colors - Pending (Warning)
export const MANGO_TANGO = " #ff8000"; // Mango Tango - pending/warning status text

// Icon colors
export const SAN_MARINO = " #3f51b5"; // San Marino - primary icon color (Material-UI indigo)

// Chemistry/Element colors
export const ORANGE_WEB = " #ffa500"; // Orange Web - below minimum limit indicator
export const LIGHT_CARMINE_PINK = " #f26b6b"; // Light Carmine Pink - above maximum limit indicator
